namespace Areas.Dailies {
    "use strict";


    //
    //CRUD functions
    //
    export function initializeRow(e: any) {

        var dataGrid = $('#DailyReportGrid').dxDataGrid('instance');
        var dailyReportId = dataGrid.option('dailyReportId');

        e.data.dailyReportId = dailyReportId;
    }

    var formDailiesClose;

    var formCrudOps: FormCrudOperations;
    $(() => { init(); });

    function init() {

        formCrudOps = new FormCrudOperations("Dailies");
        formDailiesClose = new UpdateOperations("DailiesForm", "/Dailies/Edit/CloseDaily");

    }


    export function closeDaily(e: any) {
        formDailiesClose.updateRecordWithId();
    }

    export function insertRecord(e: any) {
        formCrudOps.insertRecord();
    }

    export function updateRecord(e: any) {
        formCrudOps.updateRecord();
    }

    export function voidRecord() {
        const verifyVoid = window.confirm("Are you sure you would like to Delete this record?");

        if (verifyVoid) {
            const form = $("#DailiesForm").dxForm("instance");
            const keyId: any = form.option("KeyId");
            const projectId = form.option("ProjectId");

            if (keyId != null && projectId != null) {
                sendRequest(`/Dailies/Edit/VoidDailies/${keyId}/${projectId}/`, "", "PUT");
            }
        }
    }

}


